var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxingbag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 53,
    viewBox: "0 0 27 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3847 0.538086C10.8324 0.538086 10.3847 0.985802 10.3847 1.53809V10.9226H3C1.34315 10.9226 0 12.2657 0 13.9226V49.4611C0 51.1179 1.34315 52.4611 3 52.4611H24C25.6569 52.4611 27 51.1179 27 49.4611V13.9226C27 12.2657 25.6569 10.9226 24 10.9226H16.6154V1.53809C16.6154 0.985801 16.1677 0.538086 15.6154 0.538086H11.3847ZM16.6153 39.0154C16.6154 39.0102 16.6154 39.0049 16.6154 38.9996V21.208C16.6274 20.1138 17.5182 19.2304 18.6153 19.2304H20.8461C21.9507 19.2304 22.8461 20.1258 22.8461 21.2304V46.3073C22.8461 47.4119 21.9507 48.3073 20.8461 48.3073H18.6153C17.5108 48.3073 16.6153 47.4119 16.6153 46.3073V39.0154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxingbag);
export default __webpack_public_path__ + "static/media/boxingbag.e2b8e3ee26cc2afdb5f2c39449e315f5.svg";
export { ForwardRef as ReactComponent };